import React from 'react';
import { Button, HStack } from '@chakra-ui/react';

const gradientStyles = {
  background: 'linear-gradient(135deg, #60a5fa, #4f46e5)',
  color: 'white',
  border: 'none',
  _hover: { opacity: 0.92, transform: 'translateY(-1px)' },
  _active: { opacity: 0.88 },
  _disabled: { opacity: 0.55, cursor: 'not-allowed' },
};

export function FormActions({ children, ...props }) {
  return (
    <HStack gap={2} flexWrap="wrap" mt={4} {...props}>
      {children}
    </HStack>
  );
}

export function PrimaryButton(props) {
  return (
    <Button
      type="submit"
      colorPalette="brand"
      borderRadius="lg"
      fontWeight="medium"
      css={gradientStyles}
      {...props}
    />
  );
}

export function SecondaryButton(props) {
  return (
    <Button
      type="button"
      variant="outline"
      colorPalette="gray"
      borderRadius="lg"
      fontWeight="medium"
      {...props}
    />
  );
}

export function LinkButton(props) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      colorPalette="brand"
      fontWeight="medium"
      px={0}
      h="auto"
      minH="auto"
      {...props}
    />
  );
}
